<template>
    <v-btn @click="onClick"
           :disabled="isDisabled"
           content="My Edits"
           v-tippy="{placement: 'right', boundary: 'window'}"
    >
        <v-icon class="material-symbols-outlined">edit_note</v-icon>
    </v-btn>
</template>

<script>
import { mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],

    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("UI", ['showLutPreviews']),
        ...mapState("Projects", ['image']),
        isDisabled() {
            return !this.canUseColorGradingTools || this.blockLoading || !this.image || this.IDT.initial
        }
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks');
        },
    },
};
</script>